define('viewmodels/ProductRiskRating/ProductRatingSetup',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {
        var app = require('durandal/app'),
            ko = require('knockout');

        var ProductRatingSetupVM = {
            attached: attached,
            popUpTitle: ko.observable(),
            onOpenScaleModal: onOpenScaleModal,
            closeModal: closeModal,
            //Scale Types
            addRows: addRows,
            deleteRow: deleteRow,
            scaleTypes: [
                { name: 'Single Value Scale' },
                { name: 'Range Value Scale' },
                { name: 'Matrix Scale' }
            ],
            currentlySelectedScaleType: ko.observable('Single Value Scale'),
            selectedScaleType: ko.observable(new SingleValueScaleModel({})),
            //Signle Value Scale
            singleValueScalesCollection: ko.observableArray([
                {
                    id: 1,
                    name: 'SVS',
                    numberOfLevels: 3,
                    finalScale: true,
                    details: [
                        { id: 1, riskScore: 1, definition: '', description: '', rating: '' },
                        { id: 2, riskScore: 2, definition: '', description: '', rating: '' }
                    ]
                }
            ]),
            addNewSingleValueScale: addNewSingleValueScale,
            //Range Value Scale
            rangeValueScalesCollection: ko.observableArray([]),
            addNewRangeValueScale: addNewRangeValueScale,
            scaleTypesMap: [
                { name: 'Likerit' },
                { name: 'Percentage' }
            ],
            //Matrix Scale
            matrixScalesCollection: ko.observableArray([]),
            addNewMatrixScale: addNewMatrixScale
        };

        return ProductRatingSetupVM;

        function attached() {
            // Change currently selected Scale Object
            ProductRatingSetupVM.currentlySelectedScaleType.subscribe(function (newValue) {
                switch (newValue) {
                    case 'Single Value Scale':
                        ProductRatingSetupVM.selectedScaleType(new SingleValueScaleModel({}));
                        break;
                    case 'Range Value Scale':
                        ProductRatingSetupVM.selectedScaleType(new RangeValueScaleModel({}));
                        break;
                    case 'Matrix Scale':
                        ProductRatingSetupVM.selectedScaleType(new MatrixScaleModel({}));
                        break;
                }
            });
        }

        function onOpenScaleModal() {
            ProductRatingSetupVM.popUpTitle("Add New Risk Scale");
        }
        function closeModal() {
            $('#newScale').modal('hide');
        }


        /**
         * Models
         **/

        function addRows(numOfLevels, scaleDetail) {
            var numOfLevels = ProductRatingSetupVM.selectedScaleType().numberOfLevels();
            var scaleDetail = ProductRatingSetupVM.selectedScaleType().details();

            for (var i = 0; i < numOfLevels; i++) {
                switch (ProductRatingSetupVM.currentlySelectedScaleType()) {
                    case 'Single Value Scale':
                        scaleDetail.push(new SingleValueScaleModelDetail({}));
                        break;
                    case 'Range Value Scale':
                        scaleDetail.push(new RangeValueScaleModelDetail({}));
                        break;
                    case 'Matrix Scale':
                        scaleDetail.push(new MatrixScaleDetailModel({}));
                        break;
                }
            }
        }

        function deleteRow() {
        }


        /** Single Value Scale **/
        function SingleValueScaleModel(data) {
            var self = this;
            self.id = data.id || null;
            self.name = ko.observable(data.name || '');
            self.numberOfLevels = ko.observable(data.numberOfLevels || 1);
            self.details = ko.observableArray(data.details || []);
            self.finalScale = ko.observable(data.finalScale || true);
        }

        function SingleValueScaleModelDetail(data) {
            var self = this;
            self.id = data.id || null;
            self.riskScore = ko.observable(data.riskScore || 1);
            self.definition = ko.observable(data.definition || '');
            self.description = ko.observable(data.description || '');
            self.rating = ko.observable(data.rating || '');
        }

        function addNewSingleValueScale() {
            addRows();
            var newSingleValueScale = ko.toJS(ProductRatingSetupVM.selectedScaleType());

            if (newSingleValueScale.name == '') {
                $('#valError').show();
                $('#valError').text('Risk Scale Nane cannot be empty!');
                return false;
            } else {
                ProductRatingSetupVM.singleValueScalesCollection.push(newSingleValueScale);
                ProductRatingSetupVM.singleValueScalesCollection();
                ProductRatingSetupVM.selectedScaleType(new SingleValueScaleModel({}));
                closeModal();
            }
        }
        /**End of Single Value Scale **/

        /** Range Value Scale **/
        function RangeValueScaleModel(data) {
            var self = this;
            self.id = data.id || null;
            self.name = ko.observable(data.name || '');
            self.numberOfLevels = ko.observable(data.numberOfLevels || 1);
            self.scaleType = ko.observable(data.scaleType || 'Percentage');
            self.details = ko.observableArray(data.details || []);
            self.finalScale = ko.observable(data.finalScale || true);
        }


        function RangeValueScaleModelDetail(data) {
            var self = this;
            self.id = data.id || null;
            self.description = ko.observable(data.description || '');
            self.definition = ko.observable(data.definition || '');
            self.rating = ko.observable(data.rating || '');
            self.min = ko.observable(data.min || null);
            self.max = ko.observable(data.max || null);
        }

        function addNewRangeValueScale() {
            addRows();

            var newRangeValueScale = ko.toJS(ProductRatingSetupVM.selectedScaleType);
            ProductRatingSetupVM.rangeValueScalesCollection().push(newRangeValueScale);
            ProductRatingSetupVM.selectedScaleType(new RangeValueScaleModel({}));
            closeModal();
        }
        /**End of Range Value Scale **/

        function MatrixScaleModel(data) {
            var self = this;
            self.id = data.id || null;
            self.name = ko.observable(data.name || '');
            self.numberOfLevels = ko.observable(data.numberOfLevels || 1);
            self.preferredXAxis = ko.observable(data.preferredXAxis || '');
            self.preferredYAxis = ko.observable(data.preferredYAxis || '');
            self.finalScale = ko.observable(data.finalScale || true);
            self.details = ko.observableArray(data.details || []);
        }

        function MatrixScaleDetailModel(data) {
            var self = this;
            self.id = data.id || null;
            self.riskScore = ko.observable(data.riskScore || 1);
            self.definition = ko.observable(data.definition || '');
            self.description = ko.observable(data.description || '');
            self.rating = ko.observable(data.rating || '');
        }

        function addNewMatrixScale() {
            addRows();

            var newMatrixScale = ko.toJS(ProductRatingSetupVM.selectedScaleType);
            ProductRatingSetupVM.matrixScalesCollection().push(newMatrixScale);
            ProductRatingSetupVM.selectedScaleType(new MatrixScaleModel({}));
        }

    });

